import { render, staticRenderFns } from "./OnionReports.vue?vue&type=template&id=f8af07a2&scoped=true&"
import script from "./OnionReports.vue?vue&type=script&lang=js&"
export * from "./OnionReports.vue?vue&type=script&lang=js&"
import style0 from "./OnionReports.vue?vue&type=style&index=0&id=f8af07a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8af07a2",
  null
  
)

export default component.exports